export default "__VITE_ASSET__C3588IY6__"